import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex'
  },
  containerList: {
    width: '100%',
    cursor: 'pointer',
    backgroundColor: '#F2F3F4',
    '&:hover': {
      backgroundColor: '#EAEDED'
    }
  },
  title: {
    fontWeight: 'bold',
    marginBlock: 10
  },
  separator: {
    backgroundColor: 'black',
    border: 0,
    height: 1
  },
  nameStyle: {
    display: 'flex',
    marginLeft: 10
  }
}))

export default useStyles
